class Dropdown extends HTMLElement {
  constructor() {
    super();

    this.list = this.querySelector(".dropdown__list");
    this.valueLabel = this.querySelector(".dropdown__value");
    this.options = this.list.querySelectorAll("input");

    this.addEventListener("click", () => {
      if (this.list.classList.toggle("dropdown__list--visible"))
        document.addEventListener("click", this.onOutsideClick.bind(this));
      else
        document.removeEventListener("click", this.onOutsideClick.bind(this));
    });

    this.options.forEach((option) => {
      option.addEventListener("change", (e) => {
        this.onOptionChange(e.target.value);
        this.list.classList.remove("dropdown__list--visible");
        document.removeEventListener("click", this.onOutsideClick.bind(this));
      });
    });
  }

  onOutsideClick(e) {
    const closestDropdown = e.target.closest("custom-dropdown");

    if (!closestDropdown || closestDropdown !== this)
      this.list.classList.remove("dropdown__list--visible");
  }

  onOptionChange(value) {
    this.valueLabel.innerHTML = value;
  }
}

if (!customElements.get("custom-dropdown"))
  customElements.define("custom-dropdown", Dropdown);
